document.addEventListener('DOMContentLoaded', function() {
  // Skip if animations aren't supported
  if (!window.AnimationEvent) return;

  // Handle all internal links
  document.querySelectorAll('a').forEach(anchor => {
    // Skip if:
    // - External link
    // - Same page anchor
    // - Has no-fade class
    // - Is a download link
    if (anchor.hostname !== window.location.hostname || 
        anchor.pathname === window.location.pathname ||
        anchor.classList.contains('no-fade') ||
        anchor.hasAttribute('download') ||
        anchor.getAttribute('href') === '#' ||
        anchor.getAttribute('href').startsWith('javascript:')) {
      return;
    }

    anchor.addEventListener('click', function(event) {
      const fader = document.getElementById('fader');
      const href = this.href;

      // Don't intercept if the link opens in new tab
      if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) {
        return;
      }

      const animationEndHandler = function() {
        window.location = href;
        fader.removeEventListener('animationend', animationEndHandler);
      };
      
      fader.addEventListener('animationend', animationEndHandler);
      event.preventDefault();
      fader.classList.add('fade-in');
    });
  });

  // Handle back/forward cache
  window.addEventListener('pageshow', function(event) {
    const fader = document.getElementById('fader');
    if (event.persisted) {
      fader.classList.remove('fade-in');
    }
    fader.classList.add('fade-out');
  });
});